//#region IMPORT
import React, { useEffect } from 'react';
import { BusinessGridCommon } from '../../../../../Components/BusinessGridCommon';
import GridFunctions from '../../../../../Services/agGrid/ag-Grid-functions';
import { Tooltip, Button, TextField, InputAdornment } from '@mui/material';
import { Dialog } from '../../../../../Components/MUIs';
import 'react-h5-audio-player/lib/styles.css';
import { AgGridReact } from 'ag-grid-react';
import { Search as SearchIcon } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { getColumnDefs1, getColumnDefs2 } from './TRA_NEW_01_ColumnDefs';

function TRA_NEW_01(props) {
  const searchInfo = useSelector((state) => state.SearchInfo);
  const columnDefs1 = getColumnDefs1(props);
  const columnDefs2 = getColumnDefs2(props);

  //#region AuthButton 이벤트
  useEffect(() => {
    if (props.filterClick1) {
      if (!props.validateSelection()) {
        props.setFilterClick1(false);
        return;
      }

      props.gridRef1.current.api.setQuickFilter(searchInfo.searchText);
      props.setFilterClick1(false);
    }
    if (props.searchClick1) {
      props.ResetLogic1();
      if (!props.validateSelection()) {
        props.setSearchClick1(false);
        return;
      }

      props.SearchLogic1(searchInfo.custCd);
      props.setSearchClick1(false);
    }
    if (props.addClick1) {
      if (!props.validateSelection()) {
        props.setAddClick1(false);
        return;
      }

      GridFunctions.addClick(props.gridRef1);
      props.setAddClick1(false);
    }
    if (props.saveClick1) {
      if (!props.validateSelection()) {
        props.setSaveClick1(false);
        return;
      }
      props.setSaveClick1(false);
    }
    if (props.deleteClick1) {
      if (!props.validateSelection()) {
        props.setDeleteClick1(false);
        return;
      }
      props.DeleteLogic1();
      props.setDeleteClick1(false);
    }
    if (props.printClick1) {
      if (!props.validateSelection()) {
        props.setPrintClick1(false);
        return;
      }
      props.PrintLogic1();
      props.setPrintClick1(false);
    }
    if (props.listClick1) {
      if (!props.validateSelection()) {
        props.setListClick1(false);
        return;
      }

      props.setModalToggle3(true);
      props.SearchLogic4();
      props.setListClick1(false);
    }
  }, [
    props.filterClick1,
    props.searchClick1,
    props.addClick1,
    props.saveClick1,
    props.deleteClick1,
    props.printClick1,
    props.listClick1,
  ]);
  //#endregion

  return (
    <React.Fragment>
      <BusinessGridCommon
        getRowId={(params) => {
          return params.data.no;
        }}
        title1={'교육현황'}
        addYn1="N"
        deleteYn1="N"
        refreshClick1={(e) => {
          if (!props.validateSelection()) return;

          props.SearchLogic1();
        }}
        gridRef={props.gridRef1}
        columnDefs={columnDefs1}
        rowData={props.rowData1}
        setSelectedRowData={props.setSelectedRowData1}
        setChangedRowData={props.setChangedRowData1}
        onCellClicked={(e) => {
          // 필요 시 특정 행 선택 등 처리
          const gridApi = props.gridRef1.current.api;
          const clickedRowIndex = e.rowIndex;

          const isCheckboxClick = e.event?.target?.type === 'checkbox';

          if (!isCheckboxClick) {
            gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
            gridApi.setFocusedCell(clickedRowIndex, 'NAME');

            const copied = JSON.parse(JSON.stringify(e.data));
            props.HandleRowSelection(copied, clickedRowIndex);

            gridApi
              .getDisplayedRowAtIndex(clickedRowIndex)
              ?.setSelected(true, true);
          }
        }}
        onSelectionChanged={() => {
          const gridApi = props.gridRef1?.current?.api;
          const selectedNodes = gridApi.getSelectedNodes();
          const selectedData = selectedNodes.map((n) => n.data);
          props.selectedRowNosRef.current = new Set(
            selectedData.map((r) => r.no)
          );
          props.setSelectedRowData1(selectedData);
        }}
        rowSelection={'multiple'}
      />
      {/* TBM 실시 내역 팝업 창 */}
      {props.modalToggle1 && (
        <div
          role="presentation"
          className="MuiDialog-root MuiModal-root"
          inert="true"
        >
          <Dialog
            title={
              <>
                TBM 실시 내역
                <TextField
                  placeholder="검색"
                  variant="outlined"
                  size="small"
                  sx={{
                    mx: 2,
                    '& .MuiOutlinedInput-root': {
                      paddingRight: 0,
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" sx={{ height: '100%' }}>
                        <Button
                          edge="end"
                          size="small"
                          sx={{
                            borderLeft: 1,
                            borderColor: 'divider',
                            color: 'rgba(0, 0, 0, 0.54)', // 기본 색상
                          }}
                          style={{
                            padding: '0px',
                            borderRadius: '0px',
                            borderTopRightRadius: '8px',
                            borderBottomRightRadius: '8px',
                          }}
                          onClick={() =>
                            props.gridRef2.current.api.setQuickFilter(
                              props.modalSearchText
                            )
                          }
                        >
                          <SearchIcon sx={{ m: 0 }} style={{ margin: '0px' }} />
                        </Button>
                      </InputAdornment>
                    ),
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      props.gridRef2.current.api.setQuickFilter(
                        props.modalSearchText
                      );
                    }
                  }}
                  value={props.modalSearchText}
                  onChange={(e) => props.setModalSearchText(e.target.value)}
                />
              </>
            }
            open={props.modalToggle1}
            onClose={(e) => {
              props.setModalToggle1(false);
            }}
            contentSx={{ display: 'flex', flexDirection: 'column' }}
            fullWidth
            saveButtonName={'선택'}
            closeButtonName={'닫기'}
            useSaveButton={false}
            useSaveAfterClose={true}
            maxWidth="md"
            onSave={() => {
              if (props.selectedModalRowData1.length > 0) {
                const selected = props.selectedModalRowData1[0];
                props.onSave?.(selected);
                props.setModalToggle1(false);

                setTimeout(() => {
                  props.HandleRowSelection(selected);
                }, 100);
              }
            }}
            content={
              <div
                className="ag-theme-alpine no-scroll"
                style={{ height: '600px', width: '100%' }}
              >
                <AgGridReact
                  ref={props.gridRef2}
                  animationRows={true}
                  columnDefs={columnDefs2}
                  rowData={props.rowData2}
                  defaultColDef={{
                    minWidth: 100,
                    editable: false,
                    resizable: true,
                    sortable: true,
                    filter: true,
                    floatingFilter: true,
                  }}
                  rowSelection="single"
                  onSelectionChanged={() => {
                    GridFunctions.onSelectionChanged(
                      props.gridRef2,
                      (_selected) => {
                        props.setSelectedRowData2(_selected);
                      }
                    );
                  }}
                  getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                  onRowDoubleClicked={(e) => {
                    props.setModalToggle1(false); // 모달 닫기

                    setTimeout(() => {
                      props.HandleRowSelection(e.data);
                    }, 100);
                  }}
                />
              </div>
            }
          />
        </div>
      )}
    </React.Fragment>
  );
}

export default TRA_NEW_01;
